import { createRoot } from 'react-dom/client';

// third party
import { Provider } from 'react-redux';

// project imports
import App from 'App';
import { store } from 'store';
import { registerGlobalStatusStore } from 'utils/globalRequestStatusStore';

registerGlobalStatusStore(store);
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';

// style + assets
import 'react-h5-audio-player/src/styles.scss';
import 'assets/scss/style.scss';
import 'react-json-view-lite/dist/index.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// google-fonts
import '@fontsource-variable/heebo';

import '@fontsource/varela-round/400.css';

import '@fontsource-variable/arimo';

/** WebKit scrollbar — אחרי כל ה-CSS האחר כדי לנצח את MUI injectFirst (אחרת לא רואים שינוי בפרונט) */
import 'themes/scrollbar-chrome.css';

import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';

LicenseInfo.setLicenseKey(
  '20f611ee32ac87670daad087243df5a8Tz0xMjI2MTYsRT0xNzk2MzQyMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
);
//* Configuring Sentry
//* Sentry is a service that helps you monitor and fix crashes in real time
//* It provides a way to capture and report errors in application
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://397db141db701880a6e37bfb43a38645@o4508596059373568.ingest.de.sentry.io/4509252271079504',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
} else {
  console.log('Sentry is disabled in development mode');
}

console.log('[DEBUG-REFRESH] index.tsx executing — if you see this, it is a FULL BROWSER RELOAD', new Date().toISOString());

// ==============================|| REACT DOM RENDER ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Provider>,
);

// Initialize Stagewise toolbar in development mode
// initStagewiseToolbar(); // Commented out - function not imported

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
